import { power_supply } from './power_supply';

import { ID_GRAPH_AXIS } from '../../constants/idDefinition';
import { CHART_TYPE, SIMULATION_TYPE, UNITS_SIGN } from '../../constants/definitionConstants';

export class ncp59801cmladjtcg extends power_supply {
	constructor(opn) {
		super(opn, 'ncp59801');
		this.PACKAGE_IMAGE = require(`../../images/DFNW8_CASE_507AD.png`);
		this.SCHEMATIC_DC = require(`../../images/${this.opn}_SCH_DC.svg`);
		this.SCHEMATIC_TRAN = require(`../../images/${this.opn}_SCH_TRAN.svg`);
		this.SCHEMATIC_MC = require(`../../images/${this.opn}_SCH_DC_MC.svg`);
		this.modelLink = '';
		this.netlistPath3 = `resources/${this.wpn}/${this.opn}/netlists/${this.opn}_DC_MC.txt`;
	}

	gainDefinition() {
		const TRANSIENT_CHART_COLUMN_MAPPING = {
			TIME: 0,
			TEMP: 1,
			R_LOAD: 2,
			V_IN: 3,
			V_PG: 4,
			V_EN: 5,
			V_OUT: 6,
			I_OUT: 7,
			I_GND: 8
		};
		const MONTECARLO_CHART_COLUMN_MAPPING = {
			V_IN: 0,
			TEMP: 1,
			RUN: 2,
			V_OUT: 3,
			R_TOP: 4,
			R_BOT: 5,
			I_OUT: 6,
			I_GND: 7
		};
		const customizations = {
			simulations: [
				{
					showInputParams: false,
					inputParameters: [
						{
							/**
							 * base heading (heading is created from heading + unit)
							 */
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							/**
							 * if unit is not base unit but for example it is in kilo ohm it is needed
							 * to add extension for simulator which tells that it is kilo that’s mean ‘k’
							 */
							netlistUnit: '',
							/**
							 * exact name of parameter from netlist to be replaced
							 */
							mappingName: 'V_INmin',
							minBoundary: 1.6,
							maxBoundary: 5,
							defaultValue: 1.6
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 1.7,
							maxBoundary: 5,
							defaultValue: 5
						},
						{
							heading: 'V<sub>IN<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INstep',
							minBoundary: 0.05,
							maxBoundary: 10,
							defaultValue: 0.1
						},
						{
							heading: 'R<sub>OUT<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMin',
							minBoundary: 6.25,
							maxBoundary: 400,
							defaultValue: 6.25
						},
						{
							heading: 'R<sub>OUT<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMax',
							minBoundary: 6.3,
							maxBoundary: 401,
							defaultValue: 20
						},
						{
							heading: 'R<sub>OUT<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nLoadSteps',
							minBoundary: 1,
							maxBoundary: 25,
							defaultValue: 4,
							isInteger: true
						},
						{
							heading: 'R<sub>TOP</sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'Rup',
							minBoundary: 0,
							maxBoundary: 110,
							defaultValue: 110
						},
						{
							heading: 'R<sub>BOT</sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'Rdown',
							minBoundary: 10,
							maxBoundary: 110,
							defaultValue: 47
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -55,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					],
					schematic: {
						schematicPath: this.SCHEMATIC_DC
					},
					charts: [
						{},
						{},
						{},
						{},
						{},
						{
							/**
							 * --------------------------------------------------- V_FB vs V_IN ---------------------------------------------------
							 */
							id: 'VfbVsVin',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]FB[/] = f (V[baseline-shift: sub; font-size: 11px;]IN[/], R[baseline-shift: sub; font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_IN
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]FB[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_ADJ
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							/**
							 * --------------------------------------------------- V_PG vs V_IN ---------------------------------------------------
							 */
							id: 'VpgVsVin',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]PG[/] = f (V[baseline-shift: sub; font-size: 11px;]IN[/], R[baseline-shift: sub; font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_IN
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]PG[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_PG
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.R_LOAD
							}
						}
					]
				},
				{
					showInputParams: false,
					inputParameters: [
						{
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmin',
							minBoundary: 0,
							maxBoundary: 5,
							defaultValue: 0
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 0.1,
							maxBoundary: 5,
							defaultValue: 5
						},
						{
							heading: 't<sub>rise<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtr',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>fall<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtf',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>ON<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtON',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 300
						},
						{
							heading: 'V<sub>EN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_ENmin',
							minBoundary: 0,
							maxBoundary: 5.5,
							defaultValue: 0
						},
						{
							heading: 'V<sub>EN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_ENmax',
							minBoundary: 0.1,
							maxBoundary: 5.5,
							defaultValue: 5
						},
						{
							heading: 't<sub>EN<sub>delay</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtDelay',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>EN<sub>rise</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtr',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>EN<sub>ON</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtON',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>EN<sub>fall</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtf',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>step<sub>max</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'Tstep',
							minBoundary: 1,
							maxBoundary: 100,
							defaultValue: 10
						},
						{
							heading: 'R<sub>OUT<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMin',
							minBoundary: 6.25,
							maxBoundary: 400,
							defaultValue: 6.25
						},
						{
							heading: 'R<sub>OUT<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMax',
							minBoundary: 6.3,
							maxBoundary: 401,
							defaultValue: 20
						},
						{
							heading: 'R<sub>OUT<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nLoadSteps',
							minBoundary: 1,
							maxBoundary: 6,
							defaultValue: 4,
							isInteger: true
						},
						{
							heading: 'R<sub>TOP</sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'Rup',
							minBoundary: 0,
							maxBoundary: 110,
							defaultValue: 110
						},
						{
							heading: 'R<sub>BOT</sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'Rdown',
							minBoundary: 10,
							maxBoundary: 110,
							defaultValue: 47
						},
						{
							heading: 'C<sub>IN</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cin',
							minBoundary: 1,
							maxBoundary: 100,
							defaultValue: 4.7
						},
						{
							heading: 'ESR<sub>C<sub>IN</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCin',
							minBoundary: 0,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'C<sub>OUT</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cout',
							minBoundary: 4.7,
							maxBoundary: 100,
							defaultValue: 4.7
						},
						{
							heading: 'ESR<sub>C<sub>OUT</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCout',
							minBoundary: 0,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -55,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					],
					schematic: {
						schematicPath: this.SCHEMATIC_TRAN
					},
					charts: [
						{
							id: 'ComposedChart',
							mainHeading: 'Timing Diagram',
							chartType: CHART_TYPE.COMPOSITE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'Voltage',
									unit: UNITS_SIGN.VOLT
									/*columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
									 */
								}
							],
							composedCharts: [
								{
									id: 'VinVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]IN[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VenVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]EN[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VpgVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]PG[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VoutVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]OUT[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								}
							],
							series: {
								heading: 'Voltage dependence',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VinVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]IN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VenVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]EN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]EN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_EN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VoutVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_OUT
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'IoutVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_OUT
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'IgndVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]GND[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_GND
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VpgVsTime',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]PG[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]PG[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_PG
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						}
					]
				},
				{
					heading: 'Resistor divider - Monte Carlo analysis',
					showRawData: false,
					inputHeading: 'Input parameters',
					showInputParams: false,
					inputParameters: [
						{
							heading: 'V<sub>IN</sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'Vin',
							minBoundary: 1.6,
							maxBoundary: 5.0,
							defaultValue: 5
						},
						{
							heading: 'R<sub>OUT</sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'load',
							minBoundary: 6.5,
							maxBoundary: 400,
							defaultValue: 20
						},
						{
							heading: 'R<sub>TOP</sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'Rup',
							minBoundary: 0,
							maxBoundary: 110,
							defaultValue: 110
						},
						{
							heading: 'tol<sub>R<sub>TOP</sub></sub>',
							unit: UNITS_SIGN.PERCENT,
							netlistUnit: '',
							mappingName: 'RupTol',
							minBoundary: 0.01,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 'R<sub>BOT</sub>',
							unit: UNITS_SIGN.KILO_OHM,
							netlistUnit: 'k',
							mappingName: 'Rdown',
							minBoundary: 10,
							maxBoundary: 110,
							defaultValue: 47
						},
						{
							heading: 'tol<sub>R<sub>BOT</sub></sub>',
							unit: UNITS_SIGN.PERCENT,
							netlistUnit: '',
							mappingName: 'RdownTol',
							minBoundary: 0.01,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 'N<sub>analysis runs<sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nSim',
							minBoundary: 1,
							maxBoundary: 400,
							defaultValue: 350,
							isInteger: true
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -55,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					],
					netlist: {
						heading: 'Netlist',
						netlistPath: this.netlistPath3,
						displayNetlist: false
					},
					schematic: {
						heading: 'Application schematic',
						schematicPath: this.SCHEMATIC_MC
					},
					charts: [
						{
							id: 'Rup',
							mainHeading: 'R[baseline-shift: sub; font-size: 11px;]TOP[/] = f (runs)',
							chartType: CHART_TYPE.HISTOGRAM,
							simulationType: SIMULATION_TYPE.MONTECARLO_DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'R[baseline-shift: sub; font-size: 11px;]TOP[/]',
									unit: UNITS_SIGN.OHM,
									columnNumber: ''
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'analysis runs',
									unit: UNITS_SIGN.NOUNITS,
									columnNumber: ''
								}
							],
							series: {
								heading: '',
								unit: '',
								columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.R_TOP
							}
						},
						{
							id: 'Rdown',
							mainHeading: 'R[baseline-shift: sub; font-size: 11px;]BOT[/] = f (runs)',
							chartType: CHART_TYPE.HISTOGRAM,
							simulationType: SIMULATION_TYPE.MONTECARLO_DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'R[baseline-shift: sub; font-size: 11px;]BOT[/]',
									unit: UNITS_SIGN.OHM,
									columnNumber: ''
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'analysis runs',
									unit: UNITS_SIGN.NOUNITS,
									columnNumber: ''
								}
							],
							series: {
								heading: '',
								unit: '',
								columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.R_BOT
							}
						},
						{
							id: 'RunVsVout',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]OUT[/] = f (R[baseline-shift: sub; font-size: 11px;]TOP[/], R[baseline-shift: sub; font-size: 11px;]BOT[/])',
							chartType: CHART_TYPE.HISTOGRAM,
							simulationType: SIMULATION_TYPE.MONTECARLO_DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.VOLT,
									/**
									 * this is empty for histogram
									 */
									columnNumber: ''
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'analysis runs',
									unit: UNITS_SIGN.NOUNITS,
									/**
									 * this is empty for histogram
									 */
									columnNumber: ''
								}
							],
							series: {
								heading: '',
								unit: '',
								/**
								 * number of column in simulation result from which we want to create histogram
								 * graph (number of bins is for now defined at data processing to 10 bins)
								 */
								columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.V_OUT
							}
						},
						{
							id: 'VoutVsRuns',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/] = f (runs)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.MONTECARLO_DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'analysis runs',
									unit: UNITS_SIGN.NOUNITS,
									columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.RUN
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.V_OUT
								}
							],
							series: {
								heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/] ',
								unit: UNITS_SIGN.VOLT,
								columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.V_IN
							}
						},
						{
							id: 'IoutVsRuns',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]OUT[/] = f (runs)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.MONTECARLO_DC,
							visible: true,
							convertYAxisToMili: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'analysis runs',
									unit: UNITS_SIGN.NOUNITS,
									columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.RUN
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.MILLI_AMPER,
									columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.I_OUT
								}
							],
							series: {
								heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/] ',
								unit: UNITS_SIGN.VOLT,
								columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.V_IN
							}
						},
						{
							id: 'IgndVsRuns',
							mainHeading: 'I[baseline-shift: sub; font-size: 11px;]GND[/] = f (runs)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.MONTECARLO_DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'analysis runs',
									unit: UNITS_SIGN.NOUNITS,
									columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.RUN
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.I_GND
								}
							],
							series: {
								heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/] ',
								unit: UNITS_SIGN.VOLT,
								columnNumber: MONTECARLO_CHART_COLUMN_MAPPING.V_IN
							}
						}
					]
				}
			]
		};

		return super.gainDefinition(customizations);
	}
}
